<template>
  <div>
    <b-row class="">
      <b-col>
        <div class="position-absolute tt-alert-block">
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="success"
              size="lg"
              show=""
              v-if="deletingStatus === 'successDeletion'"
              >Expense was deleted successfully</b-alert
            >
          </transition>
          <transition
            name="alert-slide-fade"
            leave-active-class="animate__animated animate__fadeOutUp"
          >
            <b-alert
              variant="danger"
              size="lg"
              show=""
              v-if="deletingStatus === 'failedDeletion'"
            >
              There was a problem deleting the expense please try
              again.</b-alert
            >
          </transition>
        </div>
        <div v-if="!limit">
          <div>
            <h1 class="font-weight-500 text-center mb-0 mt-3">
              Vehicle expenses
            </h1>
          </div>
        </div>
        <div class="mt-md-0 mb-5 tt-mt">
          <hr class="mb-4" v-if="!limit" />
          <b-col
            class="px-0 justify-content-center text-center d-flex"
            v-if="!limit"
          >
            <b-button
              :to="'/add-expense'"
              variant="warning"
              class="w-100 py-2 btn-new text-white mb-3 tt-border-radius"
              >Add a new vehicle expense</b-button
            >
          </b-col>
          <b-list-group class="tt-border-radius">
            <b-list-group-item
              class="text-left bg-primary text-white tt-border-radius"
            >
              <div class="d-flex justify-content-between">
                <span> {{ limit ? "Saved Expenses" : "Expenses" }}</span>
                <span v-if="limit"
                  ><router-link :to="{ name: 'expenses' }" tag="span"
                    >View all vehicle expenses</router-link
                  ></span
                >
              </div>
            </b-list-group-item>
            <b-list-group-item
              v-for="expense in savedExpense"
              :key="expense._id"
              class="text-left"
              :variant="expense.is_fuel ? 'secondary' : ''"
            >
              <div class="row">
                <div class="col-10">
                  <div class="d-flex mr-2">
                    <div>
                      <b-icon
                        icon="exclamation-circle-fill"
                        variant="warning"
                        v-if="!expense.is_synced"
                        class="mr-2"
                      ></b-icon>
                      <b-icon
                        icon="check-circle-fill"
                        variant="success"
                        v-else
                        class="mr-2"
                      ></b-icon>
                    </div>
                    <div>
                      <small>{{ expense.description }}</small
                      ><br />
                      Odometer : {{ expense.odometer }} | Cost : ZAR{{
                        expense.cost
                      }}
                      | Time {{ momentJs(expense.time).format("lll") }} <br />
                      {{
                        expense.is_fuel
                          ? "Quantity: " + expense.fuel_quantity
                          : ""
                      }}
                      <p>
                        <small>{{
                          carsArr[expense.vehicle_pouch_id]
                            ? carsArr[expense.vehicle_pouch_id].make +
                              " - " +
                              carsArr[expense.vehicle_pouch_id].model
                            : defaultVehicle.make
                        }}</small>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-2">
                  <div class="d-flex" style="justify-content: end">
                    <b-icon
                      icon="pencil"
                      scale="1"
                      @click="editExpense(expense)"
                      class="mr-2"
                    ></b-icon>
                    <b-icon
                      icon="x-circle-fill"
                      scale="1"
                      variant="danger"
                      v-b-modal.modal-center
                      modal-ok.delete
                      @click="selectedExpense = expense"
                    >
                    </b-icon>
                  </div>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
      <b-modal
        id="modal-center"
        centered
        title="Delete"
        header-bg-variant="tt-bg"
      >
        <template>
          <p>Are you sure about this action ?</p>
        </template>

        <template #modal-footer="{ ok, cancel }">
          <b-button
            class="tt-button"
            @click="
              deleteExpense();
              ok();
            "
          >
            Delete
          </b-button>
          <b-button variant="danger" @click="cancel()">
            Cancel
          </b-button>
        </template>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  name: "Expense",
  data() {
    return {
      selectedExpense: ""
    };
  },

  props: {
    limit: {
      type: Boolean
    }
  },

  mounted() {
    this.$store.dispatch("expense/getExpensesAction");
  },
  computed: {
    savedExpense() {
      try {
        return this.limit === true ? this.expenses.slice(0, 10) : this.expenses;
      } catch (e) {
        return {};
      }
    },
    ...mapGetters({
      carsArr: "car/getCarsArray",
      defaultVehicle: "car/getDefaultCar"
    }),
    ...mapState({
      // vehicles: state => state.car.allCars,
      lastTripOdo: state => state.expense.lastRecordedTrip,
      error: state => state.trip.actionErrorMsg,
      success: state => state.trip.actionSuccessMsg,
      expenses: state => state.expense.all
    }),
    deletingStatus() {
      return this.error || this.success;
    },
    momentJs() {
      return moment;
    }
  },
  watch: {
    deletingStatus: function() {
      this.$store.commit("expense/clearMes");
    }
  },

  methods: {
    deleteExpense() {
      this.selectedExpense["status"] = 2;
      this.selectedExpense["is_synced"] = false;
      this.$store.commit("expense/setRecordForDeletion", this.selectedExpense);
      this.$store.dispatch("expense/getExpensesAction");
    },
    editExpense(expense) {
      //change route name and pass prop if viewing from a page other than the edit page else emit an event to update the current edited trip
      if (this.$route.name === "edit-expense") {
        this.$emit("changeEditedExpense", expense);
      } else {
        this.$router.push({
          name: "edit-expense",
          params: { editableExpense: expense }
        });
      }
    }
  }
};
</script>

<style scoped></style>
